"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const weave_1 = require("../../../app/dist/weave");
exports.toolDef = {
    name: 'loom_create_weave',
    description: "Create an empty weave folder (`loom/{weaveId}`). A weave has no manifest doc — this just materialises the directory so it appears in the tree and can hold threads/loose fibers. Refuses if the weave already exists. Use this tool — do not create weave folders directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weaveId: { type: 'string', description: 'Weave id (folder slug) to create under loom/' },
        },
        required: ['weaveId'],
    },
};
async function handle(root, args) {
    const result = await (0, weave_1.createWeave)({ weaveId: args['weaveId'] }, { getActiveLoomRoot: () => root, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
